// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"0d453f0a","488":"f5ad9e05","885":"ddce7888"}[chunkId] + ".chunk.js";
};